<template>
  <VaDropdown
    v-model="isOpen"
    :anchor="anchor"
    :placement="placement"
    :close-on-content-click="closeOnContentClick"
    :close-on-click-outside="closeOnOutsideClick"
    :content-class="contentClass"
  >
    <template #anchor>
      <span class="app_dropdown_anchor" />
    </template>
    <slot />
  </VaDropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { VaDropdown } from 'vuestic-ui'

export interface AppDropdownProps {
  readonly modelValue: boolean
  readonly anchor: string | HTMLElement
  readonly placement?: 'bottom' | 'bottom-start' | 'bottom-end' | 'top' | 'top-start' | 'top-end'
  readonly closeOnContentClick?: boolean
  readonly closeOnOutsideClick?: boolean
  /** Tailwind layer for Vuestic's teleported content wrapper. */
  readonly contentClass?: string
}

const props = withDefaults(defineProps<AppDropdownProps>(), {
  placement: 'bottom',
  closeOnContentClick: false,
  closeOnOutsideClick: true,
  contentClass: 'z-select-popover!',
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

const isOpen = computed<boolean>({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
})
</script>
